module.exports = __webpack_public_path__ + "static/media/pdf_bg_frontpage.1f45eada.png";